// =============================================================================
// TOKENS DE DASHBOARD - SISTEMA DE DISEÑO TADMIN
// =============================================================================
// Tokens para componentes del dashboard: Dashboard, LoadingSpinner, ErrorMessage, Layout

import colors from './colors.js';
import typography from './typography.js';
import spacing from './spacing.js';
import shadows from './shadows.js';
import borders from './borders.js';

// Desestructuración segura de typography
const typographyData = typography || {};
const fontSize = typographyData.fontSizes || {};
const fontWeight = typographyData.fontWeights || {};
const lineHeight = typographyData.lineHeights || {};

// =============================================================================
// TOKENS PARA DASHBOARD
// =============================================================================
export const dashboardTokens = {
  container: {
    padding: spacing.spacing[6],
    backgroundColor: colors.light.background.default,
  },
  metricsGrid: {
    display: 'grid',
    gridTemplateColumns: {
      mobile: 'repeat(1, 1fr)',
      tablet: 'repeat(2, 1fr)',
      desktop: 'repeat(4, 1fr)',
    },
    gap: spacing.spacing[4],
  },
  categorySection: {
    backgroundColor: colors.light.surface.default,
    borderRadius: borders.radius.lg,
    boxShadow: shadows.base.sm,
    padding: spacing.spacing[6],
    marginBottom: spacing.spacing[6],
  },
  categoryTitle: {
    fontSize: fontSize.lg,
    fontWeight: fontWeight.semiBold,
    color: colors.light.text.primary,
    marginBottom: spacing.spacing[4],
  },
  metricCard: {
    backgroundColor: colors.light.gray[50],
    borderRadius: borders.radius.lg,
    padding: spacing.spacing[4],
  },
  metricHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: spacing.spacing[2],
  },
  metricIcon: {
    fontSize: fontSize['2xl'],
  },
  metricDate: {
    fontSize: fontSize.sm,
    color: colors.light.text.secondary,
  },
  metricLabel: {
    fontSize: fontSize.sm,
    fontWeight: fontWeight.medium,
    color: colors.light.text.secondary,
    marginBottom: spacing.spacing[2],
  },
  metricValue: {
    fontSize: fontSize['2xl'],
    fontWeight: fontWeight.bold,
    color: colors.light.text.primary,
  },
  metricDetails: {
    marginTop: spacing.spacing[3],
    paddingTop: spacing.spacing[3],
    borderTop: `1px solid ${colors.light.border.default}`,
  },
  metricDetailsTitle: {
    fontSize: fontSize.xs,
    color: colors.light.text.secondary,
    marginBottom: spacing.spacing[2],
  },
  metricDetailsItem: {
    fontSize: fontSize.xs,
    color: colors.light.text.primary,
    marginBottom: spacing.spacing[2],
  },
  emptyState: {
    textAlign: 'center',
    paddingTop: spacing.spacing[8],
    paddingBottom: spacing.spacing[8],
  },
  emptyStateText: {
    color: colors.light.text.secondary,
  },
  initButton: {
    marginTop: spacing.spacing[4],
    padding: `${spacing.spacing[4]} ${spacing.spacing[6]}`,
    backgroundColor: colors.light.primary.main,
    color: colors.light.primary.contrast,
    borderRadius: borders.radius.md,
    '&:hover': {
      backgroundColor: colors.light.primary.dark,
    },
  },
};

// =============================================================================
// TOKENS PARA LOADING SPINNER
// =============================================================================
export const loadingSpinnerTokens = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: spacing.spacing[8],
  },
  spinner: {
    width: '2rem',
    height: '2rem',
    border: `2px solid ${colors.light.gray[200]}`,
    borderTop: `2px solid ${colors.light.primary.main}`,
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
  text: {
    marginLeft: spacing.spacing[3],
    color: colors.light.text.secondary,
    fontSize: fontSize.sm,
  },
};

// =============================================================================
// TOKENS PARA ERROR MESSAGE
// =============================================================================
export const errorMessageTokens = {
  container: {
    backgroundColor: colors.light.error.light,
    border: `1px solid ${colors.light.error.main}`,
    borderRadius: borders.radius.md,
    padding: spacing.spacing[4],
    margin: `${spacing.spacing[4]} 0`,
  },
  title: {
    color: colors.light.error.dark,
    fontSize: fontSize.sm,
    fontWeight: fontWeight.medium,
    marginBottom: spacing.spacing[2],
  },
  message: {
    color: colors.light.error.dark,
    fontSize: fontSize.sm,
  },
  icon: {
    color: colors.light.error.main,
    width: '1.25rem',
    height: '1.25rem',
    marginRight: spacing.spacing[2],
  },
};

// =============================================================================
// TOKENS PARA LAYOUT
// =============================================================================
export const layoutTokens = {
  container: {
    minHeight: '100vh',
    backgroundColor: colors.light.background.default,
  },
  header: {
    backgroundColor: colors.light.surface.default,
    borderBottom: `1px solid ${colors.light.border.default}`,
    padding: `${spacing.spacing[4]} ${spacing.spacing[6]}`,
  },
  main: {
    flex: '1',
    padding: spacing.spacing[6],
  },
  sidebar: {
    width: '16rem',
    backgroundColor: colors.light.surface.default,
    borderRight: `1px solid ${colors.light.border.default}`,
  },
};